module.exports = __webpack_public_path__ + "img/ics_o_eye_red.2dfb18d4.svg";